import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { BaseBailRule } from 'src/app/bail-rules/directives/base-bail-rule.directive';
import { AllDaysOfTheWeek, Day, DayAsString } from 'src/app/models/time';

export interface VaryingDaysSingleSessionHandlerData {
    numberOfDays: number,
    recurringDays: {
        dayOfWeek: Day
        startTime: Date | string
        endTime: Date | string
    }[]
}

@Component({
  selector: 'app-varying-days-single-session-rule-handler',
  templateUrl: './varying-days-single-session-rule-handler.component.html',
  styleUrls: ['./varying-days-single-session-rule-handler.component.scss']
})
export class VaryingDaysSingleSessionRuleHandlerComponent extends BaseBailRule<VaryingDaysSingleSessionHandlerData> implements OnInit {

    readonly DayAsString = DayAsString;

    readonly Day = Day;

    readonly AllDaysOfTheWeek = AllDaysOfTheWeek;

    isAddingNewDay = true;

    availableDays = [
        Day.Sunday,
        // Day.Monday,
        Day.Tuesday,
        Day.Wednesday,
        Day.Thursday,
        Day.Friday,
        Day.Saturday,
    ];

    formGroup = new FormGroup({
        numberOfDays: new FormControl<number>(1, [Validators.min(1), Validators.max(6), x => Validators.max((this.dailyBailConditions?.length ?? 7) - 1)(x)]),
        recurringDays: new FormArray([
            new FormGroup({
                dayOfWeek: new FormControl<Day>(Day.Monday),
                startTime: new FormControl<Date | string | null>("09:00", Validators.required),
                endTime: new FormControl<Date | string | null>("17:00", Validators.required),
            })
        ])
    });

    get dailyBailConditions(): FormArray | undefined {
        return this.formGroup?.get('recurringDays') as FormArray;
    }


    ngOnInit(): void {
        // Remove default bail condition if conditions already exist
        if (this.rule?.data?.recurringDays.length) {
            this.removeBailCondition(0);

            // Add bail conditions
            this.rule?.data.recurringDays.forEach(dayAndTime => {
                this.addBailCondition(dayAndTime.dayOfWeek, dayAndTime.startTime, dayAndTime.endTime);
            })
        }

        if(this.rule?.data?.numberOfDays != undefined) {
            this.formGroup.get('numberOfDays')?.patchValue(this.rule?.data.numberOfDays);
        }

    }

    getFormGroup(): FormGroup<any> {
        return this.formGroup;
    }

    addBailCondition(day: Day = this.availableDays[0] ?? Day.Monday, startTime: Date | string | null = "09:00", endTime: Date | string | null = "17:00") {
        const dayIndex = this.availableDays.findIndex(x => x === day);
        if(dayIndex === -1) {
            return;
        }

        this.availableDays.splice(dayIndex, 1);
        this.isAddingNewDay = true;

        this.dailyBailConditions?.push(new FormGroup({
            dayOfWeek: new FormControl<Day>(day),
            startTime: new FormControl<Date | string | null>(startTime, Validators.required),
            endTime: new FormControl<Date | string | null>(endTime, Validators.required),
        }));
        this.formGroup.get('numberOfDays')?.updateValueAndValidity();
        this.formGroup.get('numberOfDays')?.markAsTouched();

        if(!this.availableDays.length) {
            this.dailyBailConditions?.controls.forEach(x => x.get('dayOfWeek')?.disable());
        }
    }

    removeBailCondition(index: number) {
        const availableDayToAdd = this.dailyBailConditions?.at(index)?.getRawValue()?.dayOfWeek;

        if(availableDayToAdd !== undefined) {
            this.availableDays.push(availableDayToAdd);
        }

        this.availableDays.sort();

        this.dailyBailConditions?.removeAt(index);
        this.formGroup.get('numberOfDays')?.updateValueAndValidity();
        this.formGroup.get('numberOfDays')?.markAsTouched();

        this.dailyBailConditions?.controls.forEach(x => x.get('dayOfWeek')?.enable());
    }

    daySelectionChanged(event: MatOptionSelectionChange<Day>) {
        if(this.isAddingNewDay) {
            this.isAddingNewDay = false;
            return;
        }

        if (event.isUserInput) {
            // selected value
            const dayIndex = this.availableDays.findIndex(x => x === event.source.value);
            if (dayIndex === -1) {
                return;
            }
            this.availableDays.splice(dayIndex, 1);
        } else {
            // unselected value
            this.availableDays.push(event.source.value);
            this.availableDays.sort();
        }
    }
}
